<ng-container *ngIf="state$ | async; let state">
    <ng-container *ngIf="validity$ | async; let validity">
        <div class="picker-container">
            <zbd-tabbar
                [showValidIndicators]="false"
                [switchStrategy]="'event'"
                (switch)="selectCategory($event.tabCode)"
            >
                <zbd-tab
                    *ngFor="
                        let section of state.index.items;
                        trackBy: trackIndex
                    "
                    [tabTitle]="section.name.displayName"
                    [tabCode]="section.name.key"
                    [active]="section.name.key === selectedCategoryKey"
                >
                    <br />
                    <div class="row">
                        <div class="col-md-6 col-md-push-6">
                            <h5>Beratung für folgende Produkte</h5>
                            <div class="selection">
                                <picker-selection-section
                                    [env]="getEnvironment(state)"
                                    [section]="section"
                                ></picker-selection-section>
                            </div>
                        </div>
                        <div class="col-md-6 col-md-pull-6">
                            <picker-section
                                [env]="getEnvironment(state)"
                                [section]="section"
                            ></picker-section>
                        </div>
                    </div>
                </zbd-tab>
            </zbd-tabbar>
        </div>
    </ng-container>
</ng-container>
